import styled from "styled-components";

export const FranchiseBannerWrapper = styled.div`
  width: 100%;
  height: 200px;
  padding: 0px 16px;
  position: relative;
  margin-top: 20px;

  > img {
    width: 100%;
    aspect-ratio: 164 / 83;
  }

  > .franchise-title {
    width: 92%;
    position: absolute;
    justify-content: center;
    display: flex;
    top: 68px;
    background: linear-gradient(0deg, #b698c6 27.59%, #ffffff 48.28%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: esamanru;
    font-weight: 700;
    font-size: 30px;
    text-align: center;
  }

  > .franchise-subtitle {
    width: 92%;
    position: absolute;
    justify-content: center;
    display: flex;
    top: 45px;
    color: #ffffff;
    font-family: esamanru;
    font-weight: 500;
    font-size: 15px;
    text-align: center;
  }
`;

export const FranchiseButton = styled.div`
  width: 92%;
  position: absolute;
  bottom: 55px;
  display: flex;
  justify-content: center;
  .button-text {
    width: 107px;
    height: 31px;
    border-radius: 7.31px;
    font-family: esamanru;
    font-weight: 700;
    font-size: 15px;
    line-height: 31px;
    letter-spacing: 0.73px;
    text-align: center;
    background: linear-gradient(90deg, #8a61ff 0%, #a1afff 50.5%, #5faeff 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    z-index: 2;
  }

  .button {
    width: 107px;
    height: 31px;
    position: absolute;
    border-radius: 7.31px;
    border: 0.9px solid transparent;
    padding: 1px;
    background-image: linear-gradient(
      90deg,
      #8d6de8 0%,
      #ffffff 50.5%,
      #3a87d5 100%
    );
    -webkit-mask: linear-gradient(#212528 0 0) content-box,
      linear-gradient(#212528 0 0);
    -webkit-mask-composite: xor;
    background-clip: padding-box, border-box;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
  }
`;
